module.exports = __webpack_public_path__ + "img/icon-10.a4727bcc.svg";